module.exports = __webpack_public_path__ + "img/liebao-2.befaf5fd.jpg";